import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const footerLinks = [
    {
      title: '浏览内容',
      links: [
        { label: '热门推荐', path: '/' },
        { label: '电影', path: '/category/movie' },
        { label: '电视剧', path: '/category/tv' },
        { label: '综艺', path: '/category/variety' },
        { label: '动漫', path: '/category/anime' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', path: '/about' },
        { label: '联系方式', path: '/about' },
        { label: '加入我们', path: '/about' },
      ],
    },
    {
      title: '帮助支持',
      links: [
        { label: '常见问题', path: '/' },
        { label: '用户协议', path: '/' },
        { label: '隐私政策', path: '/' },
        { label: '版权声明', path: '/' },
      ],
    },
  ];

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                {t('site.name')}
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4 max-w-xs">
              {t('site.slogan')} — {t('site.description')}
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} {t('site.name')} {t('footer.rights')}
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">
              {t('footer.privacy')}
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">
              {t('footer.terms')}
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">
              {t('footer.contact')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}